/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Mediaslider_Downloading1Inputs */

const id_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengunduh...`)
};

const ms_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat turun...`)
};

const da_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader...`)
};

const de_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen...`)
};

const en_us2_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading...`)
};

const es_es2_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargando...`)
};

const es_mx2_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargando...`)
};

const fil_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagda-download...`)
};

const fr_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement…`)
};

const it_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download in corso...`)
};

const hu_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letöltés...`)
};

const nl_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met downloaden...`)
};

const no_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster ned...`)
};

const pl_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobieranie...`)
};

const pt_br2_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading...`)
};

const pt_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A descarregar...`)
};

const ro_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se descarcă...`)
};

const fi_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar ner...`)
};

const vi_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải xuống...`)
};

const tr_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndiriliyor...`)
};

const cs_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stahování...`)
};

const bg_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегляне...`)
};

const ru_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التنزيل...`)
};

const hi_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड हो रहा है...`)
};

const th_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังดาวน์โหลด...`)
};

const ja_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード中...`)
};

const zh_cn2_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading...`)
};

const zh_hant1_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading...`)
};

const ko_components_mediaslider_downloading1 = /** @type {(inputs: Components_Mediaslider_Downloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading...`)
};

/**
* | output |
* | --- |
* | "Downloading..." |
*
* @param {Components_Mediaslider_Downloading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mediaslider_downloading1 = /** @type {((inputs?: Components_Mediaslider_Downloading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mediaslider_Downloading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mediaslider_downloading1(inputs)
	if (locale === "ms") return ms_components_mediaslider_downloading1(inputs)
	if (locale === "da") return da_components_mediaslider_downloading1(inputs)
	if (locale === "de") return de_components_mediaslider_downloading1(inputs)
	if (locale === "en-US") return en_us2_components_mediaslider_downloading1(inputs)
	if (locale === "es-ES") return es_es2_components_mediaslider_downloading1(inputs)
	if (locale === "es-MX") return es_mx2_components_mediaslider_downloading1(inputs)
	if (locale === "fil") return fil_components_mediaslider_downloading1(inputs)
	if (locale === "fr") return fr_components_mediaslider_downloading1(inputs)
	if (locale === "it") return it_components_mediaslider_downloading1(inputs)
	if (locale === "hu") return hu_components_mediaslider_downloading1(inputs)
	if (locale === "nl") return nl_components_mediaslider_downloading1(inputs)
	if (locale === "no") return no_components_mediaslider_downloading1(inputs)
	if (locale === "pl") return pl_components_mediaslider_downloading1(inputs)
	if (locale === "pt-BR") return pt_br2_components_mediaslider_downloading1(inputs)
	if (locale === "pt") return pt_components_mediaslider_downloading1(inputs)
	if (locale === "ro") return ro_components_mediaslider_downloading1(inputs)
	if (locale === "fi") return fi_components_mediaslider_downloading1(inputs)
	if (locale === "sv") return sv_components_mediaslider_downloading1(inputs)
	if (locale === "vi") return vi_components_mediaslider_downloading1(inputs)
	if (locale === "tr") return tr_components_mediaslider_downloading1(inputs)
	if (locale === "cs") return cs_components_mediaslider_downloading1(inputs)
	if (locale === "bg") return bg_components_mediaslider_downloading1(inputs)
	if (locale === "ru") return ru_components_mediaslider_downloading1(inputs)
	if (locale === "uk") return uk_components_mediaslider_downloading1(inputs)
	if (locale === "ar") return ar_components_mediaslider_downloading1(inputs)
	if (locale === "hi") return hi_components_mediaslider_downloading1(inputs)
	if (locale === "th") return th_components_mediaslider_downloading1(inputs)
	if (locale === "ja") return ja_components_mediaslider_downloading1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mediaslider_downloading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mediaslider_downloading1(inputs)
	return ko_components_mediaslider_downloading1(inputs)
});
export { components_mediaslider_downloading1 as "components.mediaSlider.downloading" }